export function searchIssues (params = {})
{
    var url = new URL(window.location.origin + '/wp-json/wp/ncel/v2/issue')
    Object
        .keys(params)
        .forEach(key => url.searchParams.append(key, params[key]))

    return fetch(url);
}